var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSettingsUser = function SvgSettingsUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 11.5V13a4.5 4.5 0 0 0-4.5 4.5H4a6 6 0 0 1 6-6m0-.75a4.5 4.5 0 0 1-4.5-4.5c0-2.486 2.014-4.5 4.5-4.5s4.5 2.014 4.5 4.5-2.014 4.5-4.5 4.5m0-1.5a3 3 0 1 0 0-6 3 3 0 1 0 0 6m1.946 5.859a2.6 2.6 0 0 1 0-1.217l-.744-.43.75-1.299.744.43c.299-.283.66-.492 1.054-.61v-.858h1.5v.859c.399.118.759.33 1.054.609l.744-.43.75 1.299-.744.43c.095.4.095.816 0 1.216l.744.43-.75 1.299-.744-.43a2.6 2.6 0 0 1-1.054.61v.858h-1.5v-.859a2.6 2.6 0 0 1-1.054-.609l-.744.43-.75-1.299zm2.554.516a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"
  })));
};
export default SvgSettingsUser;